<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title">Reset Your Password</div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              v-model="username"
              label="Username or Email"
              type="text"
              :rules="nameRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="mobileNumber"
              label="Registered Mobile Number"
              type="text"
              :rules="phoneRules"
              v-mask="'(###) ###-####'"
              required
            ></v-text-field>

            <v-btn class="mt-3 btn-submit" color="#2bb9aa" @click="nextStep">
              CONTINUE
              <font-awesome-icon class="ml-1" icon="chevron-right" />
            </v-btn>
            <div class="mt-5"></div>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
      </div>
    </div>
    <div class="grey-background"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    loading: false,

    username: "",
    mobileNumber: "",

    nameRules: [v => !!v || "Username is Required"],

    phoneRules: [
      v => !!v || "Phone number is Required",
      v => v.length == 14 || "Incorrect phone number"
    ]
  }),
  methods: {
    nextStep() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("reset_request", {
          username: this.username,
          phone_number: this.mobileNumber
        })
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/password-reset-verify" });
        })
        .catch(() => {
          this.loading = false;

          this.username = "";
          this.mobileNumber = "";
        });
    }
  }
};
</script>
